'use client';
import { useRegisterShortcut } from '#pplx/frontend/apps/ask/keyboard-shortcuts-provider/registry.js';
import { useWebPlatform } from '#pplx/frontend/platform-components/useWebPlatform.js';
import { useCallback } from 'react';
/**
 * Registers the **Toggle Dictation** global shortcut (Windows app only):
 *   - Windows app: Ctrl+D
 *
 * Keybinding, label, and group are resolved from the shortcut manifest.
 *
 * Dispatches a `toggleDictation` custom event for `AskInputRightAttribution`
 * to listen to.
 *
 * Uses `isEnabled` so that on non-Windows platforms the keybinding is
 * transparent and doesn't block shortcuts lower in the stack.
 */
export function useDictationShortcut() {
    const { device: { isWindowsApp }, } = useWebPlatform();
    const handler = useCallback((e) => {
        // Prevent the browser default (Ctrl+D bookmarks the page in most browsers).
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('toggleDictation'));
    }, []);
    useRegisterShortcut({
        id: 'toggle-dictation',
        handler,
        isEnabled: isWindowsApp,
    });
}
//# sourceMappingURL=useDictationShortcut.js.map